import { Box, BoxProps, styled } from '@mui/material'
import { WIDGET_HEIGHT } from '../../base-card/const'

interface ContainerProps extends BoxProps {
  hasLink: boolean
  isOffline: boolean
}
/* function to exclude custom props from being forwarded */
const excludeProps = (excluded: string[]) => (prop: string) => !excluded.includes(prop)

/* Vehicle Widget Container */
export const StyledContainer = styled(Box, { shouldForwardProp: excludeProps(['hasLink', 'isOffline']) })<ContainerProps>(
  ({ theme, hasLink, isOffline }) => {
    return {
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.effectStyles.shadowMain,
      backgroundColor: theme.palette.background.paper,
      minHeight: WIDGET_HEIGHT,
      alignItems: 'stretch',
      minWidth: 200,
      flex: '1 1 200px',
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      cursor: hasLink && !isOffline ? 'pointer' : 'default',

      [theme.breakpoints.down('sm')]: {
        flexBasis: 'unset',
        minWidth: 'unset',
        minHeight: 'unset',
        height: '100%',
      },
    }
  }
)

export const StyledTopRow = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 1,
  }
})

export const StyledControl = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 1,

    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
    },
  }
})
